/**
Author - Muhamed Afsal
Git - https://bitbucket.org/mohdafsal/
**/

import {WealthyEnv} from "helpers";

const teamMembers = [
  {
    name: "Aditya Agarwal",
    designation: "Co-Founder",
    avatar: `${WealthyEnv.CDN_URL}/team/Aditya-Agarwal-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/adagarwal",
    twitter_profile: "https://twitter.com/agarwaladitya",
    description: "IIT Bombay"
  },
  {
    name: "Prashant Gupta",
    designation: "Co-Founder",
    avatar: `${WealthyEnv.CDN_URL}/team/Prashant-Gupta-compressed.jpg`,
    linkedin_profile: "https://in.linkedin.com/in/prashant-gupta-1b884b6",
    twitter_profile: "https://twitter.com/7prashantg",
    description: "IIT Madras, IIM Ahmedabad, Morgan Stanley"
  },
  {
    name: "Somit Srivastava",
    designation: "Chief Technical Officer",
    avatar: `${WealthyEnv.CDN_URL}/team/Somit-Srivastava-compressed.jpg`,
    linkedin_profile: "http://in.linkedin.com/in/somitsrivastava",
    twitter_profile: "https://twitter.com/somitpisces",
    description: "BIT Mesra, HashedIn, Ola Cabs"
  },
  {
    name: "Hitesh Sachdev",
    designation: "Software Engineer",
    avatar: `${WealthyEnv.CDN_URL}/team/Hitesh-Sachdev-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/hitesh-sachdev-013308150/",
    twitter_profile: "",
    description: "DAIICT, Former Software Engineer at Treebo Hotels"
  },
  {
    name: "Muhamed Afsal V P",
    designation: "Software Engineer",
    avatar: `${WealthyEnv.CDN_URL}/team/Muhamed-Afsal-V-P-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/muhamed-afsal-3283141b7/",
    twitter_profile: "",
    description: "Calicut University"
  },
  {
    name: "Savant Chandan",
    designation: "Senior Vice President - Wealth Management",
    avatar: `${WealthyEnv.CDN_URL}/team/Savant-Chandan-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/thinksavant/",
    twitter_profile: "https://twitter.com/savanTThink",
    description: "MBA - Systems and Finance Marketing, Ex-state Head of Axis Mutual Fund, HDFC AMC"
  },
  {
    name: "Mohd. Mujtaba",
    designation: "Software Engineer",
    avatar: `${WealthyEnv.CDN_URL}/team/Mohd.-Mujtaba-compressed.jpg`,
    linkedin_profile: "https://linkedin.com/in/mohdmujtaba/",
    twitter_profile: "https://twitter.com/programmermohd",
    description: "Lovely Professional University"
  },
  {
    name: "Jameerbasha",
    designation: "Software Engineer",
    avatar: `${WealthyEnv.CDN_URL}/team/Jameerbasha-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/jameerbasha/",
    twitter_profile: "https://twitter.com/JAMEERBASHA1998",
    description: "Lovely Professional University"
  },
  {
    name: "Ramprasad Mondal",
    designation: "Software Engineer",
    avatar: `${WealthyEnv.CDN_URL}/team/Ramprasad-Mondal-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/ramprasad-mondal/",
    twitter_profile: "",
    description: "B.Tech. in Electrical Engineering"
  },
  {
    name: "Om Athalye",
    designation: "Software Development Engineer",
    avatar: `${WealthyEnv.CDN_URL}/team/om-athalye.jpg`,
    linkedin_profile: "",
    twitter_profile: "",
    description: " BE Electronics and Instrumentation + Msc Mathematics, Bits Pilani University K.K.Birla Goa Campus (2020)"
  },
  {
    name: "Brijesh Pandey",
    avatar: `${WealthyEnv.CDN_URL}/team/brijesh-pandey.jpg`,
    designation: "Software Enigineer",
    linkedin_profile: "https://www.linkedin.com/in/pbrijesh/",
    twitter_profile: "",
    description: "Galgotias University"
  },
  {
    name: "Varun Krishna",
    designation: "Vice President - Wealth Management",
    avatar: `${WealthyEnv.CDN_URL}/team/Varun-Krishna-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/varunkrishnacfp/",
    twitter_profile: "",
    description: "CFP, CWM & AIM certifications"
  },
  {
    name: "Sreenivasan Iyer",
    designation: "Lead, Content & Editorial",
    avatar: `${WealthyEnv.CDN_URL}/team/Sreenivasan-Iyer-compressed.jpg`,
    linkedin_profile: "https://in.linkedin.com/in/sreenivasaniyer",
    twitter_profile: "https://twitter.com/ahamsreeni",
    description: "Belong.co, Housing.com, Star Sports, JP Morgan"
  },
  {
    name: "Amiya Kumar Sahoo",
    designation: "Manager - Growth Marketing",
    avatar: `${WealthyEnv.CDN_URL}/team/Amiya-Kumar-Sahoo-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/amiyaksahoo/",
    twitter_profile: "https://twitter.com/amiyak4",
    description: "MBA in Marketing with 2+ years of experience in Digital Marketing"
  },
  {
    name: "Chitranjan Sharma",
    designation: "Head - Customer Success",
    avatar: `${WealthyEnv.CDN_URL}/team/Chitranjan-Sharma-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/chitranjan-sharma-944b569/",
    twitter_profile: "https://twitter.com/chitshar",
    description: "MDU Rohtak, PayU Payments Pvt Ltd, Trinity Group India"
  },
  {
    name: "Syed Tanveer Pasha",
    designation: "Senior Manager - Operations",
    avatar: `${WealthyEnv.CDN_URL}/team/Syed-Tanveer-Pasha-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/syed-tanveer-pasha-559276119/",
    twitter_profile: "",
    description: "Ex-ING Vysya Bank, IMMPL"
  },
  {
    name: "Divyani Marothia",
    designation: "Manager - Finance",
    avatar: `${WealthyEnv.CDN_URL}/team/Divyani-Marothia-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/divyani-marothia-37a5a1b6/",
    twitter_profile: "https://twitter.com/DivyaniMarothia",
    description: "Chartered Accountant, B.Com - St. Xavier's, Calcutta"
  },
  {
    name: "Akhil Kumar Reddy",
    designation: "Manager Operations (Insurance)",
    avatar: `${WealthyEnv.CDN_URL}/team/akhil-kumar-reddy.jpeg`,
    linkedin_profile: "",
    twitter_profile: "",
    description: "PGDM Finance Graduate, Assistant Manager Risk Services - SecureNow Insurance Brokers Pvt. Ltd"
  },
  {
    name: "Srimanta patra",
    designation: "Vice President - Wealth Management",
    avatar: `${WealthyEnv.CDN_URL}/team/Srimanta-Patra-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/srimanta-patra/",
    twitter_profile: "https://twitter.com/SrimantaPatra6",
    description: "MA(Literature), Ex-ICICI Securities"
  },
  {
    name: "Saurabh Kumar",
    designation: "Senior Manager",
    avatar: `${WealthyEnv.CDN_URL}/team/Saurabh-Kumar-compressed.jpg`,
    linkedin_profile: "https://www.linkedin.com/in/saurabh-kumar-513616140/",
    twitter_profile: "https://twitter.com/KUMARSAURABHJHA",
    description: "Ex-HDFC Bank, Yomillio.com, Bharti Airtel"
  },
  {
    name: "Amandeep kaur",
    designation: "Associate Vice President",
    avatar: `${WealthyEnv.CDN_URL}/team/amandeep-kaur.jpg`,
    linkedin_profile: "",
    twitter_profile: "",
    description: "Btech, Ex-Axis bank (Relationship Manager), Ex-HDFC bank (Preferred Relationship Manager)"
  },
  {
    name: "Bhavya Ronak Joshi",
    avatar: `${WealthyEnv.CDN_URL}/team/bhavya-ronak-joshi.jpg`,
    designation: "Senior Manager (PST)",
    linkedin_profile: "",
    twitter_profile: "",
    description: "4 years of experience in Banking field, Ex-Axis Bank (Assistant Manager)"
  },
  {
    name: "Anindya Chanda",
    avatar: `${WealthyEnv.CDN_URL}/team/Anindya-Chanda.jpg`,
    designation: "Product Manager",
    linkedin_profile: "https://www.linkedin.com/in/anindyachanda07/",
    twitter_profile: "",
    description: "Former engineer, SaaS maker, sales and marketing consultant"
  },
  {
    name: "Aditya Sharma",
    avatar: `${WealthyEnv.CDN_URL}/team/Aditya-Sharma.png`,
    designation: "Software Engineer",
    linkedin_profile: "https://www.linkedin.com/in/aditya-sharma26/",
    twitter_profile: "https://twitter.com/BetaPundit",
    description: "Former Product Engineer at Wipro"
  },
  {
    name: "Suyash Chandra",
    avatar: `${WealthyEnv.CDN_URL}/team/Suyash-Chandra.png`,
    designation: "Software Engineer",
    linkedin_profile: "https://www.linkedin.com/in/suyash-chandra-98955213b/",
    twitter_profile: "",
    description: "B.Tech. in Computer Science Engineering, KIIT(2019)"
  },
  {
    name: "Ratheesh P",
    avatar: `${WealthyEnv.CDN_URL}/team/Ratheesh-P.jpeg`,
    designation: "Vice President - Wealth Management",
    linkedin_profile: "https://www.linkedin.com/in/ratheesh-p-vasudevan-61b7a05b",
    twitter_profile: "",
    description: "Vice President- Wealth Management Ex Karvy | Right horizon | ICICI Prulife"
  },
  {
    name: "Siddharth Mewada",
    avatar: `${WealthyEnv.CDN_URL}/team/Siddharth-Mewada.jpg`,
    designation: "Associate Product Manager",
    linkedin_profile: "https://www.linkedin.com/in/siddharth-mewada-154018b8",
    twitter_profile: "https://twitter.com/Siddy1795",
    description: "B.Tech IIT Bombay, Ex Senior Associate IPAC, Ex Project Manager Sharayu Group"
  },
  {
    name: "Roja K U",
    avatar: `${WealthyEnv.CDN_URL}/team/Roja-K-U.jpg`,
    designation: "Manager (PST)",
    linkedin_profile: "https://www.linkedin.com/in/roja-k-umesh-3964bb223",
    twitter_profile: "",
    description: "B.com , Pursuing CS(Company Secretary) Ex-HDFC Bank (Relationship Manager)"
  },
  {
    name: "Lakshmipathy Raju",
    avatar: `${WealthyEnv.CDN_URL}/team/Lakshmipathy-Raju.jpeg`,
    designation: "Manager (PST)",
    linkedin_profile: "",
    twitter_profile: "",
    description: "Btech(E&C) Ex-KOTAK MAHINDRA BANK(Assistant Manager)"
  },
  {
    name: "KESAVAN J",
    avatar: `${WealthyEnv.CDN_URL}/team/Kesavan-J.png`,
    designation: "Graphic Designer",
    linkedin_profile: "https://www.linkedin.com/in/keshavanz/",
    twitter_profile: "https://twitter.com/keshavanz/",
    description: "Ex-Unacademy | Ex-ShareIT | Ex-Nestle | Ex-SIPPO"
  },
  {
    name: "Abhishek Mishra",
    avatar: `${WealthyEnv.CDN_URL}/team/Abhshek-Mishra.jpeg`,
    designation: "Senior Manager - Partner Success Team",
    linkedin_profile: "https://www.linkedin.com/in/abhishek-mishra-672029157",
    twitter_profile: "",
    description: "Ex- Preferred Relationship Manager (HDFC Bank) MBA (Marketing and Operations)"
  },
  {
    name: "Lakshmi Malekar",
    avatar: `${WealthyEnv.CDN_URL}/team/Lakshmi-Malekar.jpeg`,
    designation: "Assistant Manager",
    linkedin_profile: "https://www.linkedin.com/in/lakshmi-malekar-88571676",
    twitter_profile: "",
    description: "MBA-Finance, Ex-Axis bank "
  },
  {
    name: "V.RUGMINI",
    avatar: `${WealthyEnv.CDN_URL}/team/V-Rugmini.jpg`,
    designation: "MANAGER (PST)",
    linkedin_profile: "https://www.linkedin.com/in/v-rugmini-16a80362",
    twitter_profile: "",
    description: "B.B.A LL.B, LL.M "
  },
  {
    name: "Manish Dubey",
    avatar: `${WealthyEnv.CDN_URL}/team/Manish-Dubey.jpeg`,
    designation: "Manager (PST)",
    linkedin_profile: "",
    twitter_profile: "",
    description: "B-tech (Mechanical), Ex- Axis Bank (Assistant Manager) "
  }
];

export default teamMembers;
